var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "main",
    {
      staticClass: "d-flex flex-column gr-4",
      attrs: { "data-qa": "document_content" },
    },
    [
      _setup.isMobile
        ? _c(_setup.DocumentMobileBanner, {
            attrs: {
              "static-path": _setup.staticPath,
              "is-russia": _setup.isRussia,
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _setup.isMobile && _setup.companyCardHref
        ? _c(
            "section",
            {
              staticClass: "pa-4 elevation-1 rounded-sm",
              class: { "px-4": _setup.isMobile },
              attrs: { "data-qa": "document_company_card_download" },
            },
            [
              _c(_setup.DocumentDownloadLink, {
                attrs: {
                  href: _setup.companyCardHref,
                  label: _setup.t("Скачать карточку компании", _setup.options),
                },
              }),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(_setup.AddressSection, {
        class: { "px-4": _setup.isMobile },
        attrs: {
          title: _setup.addressTitle,
          items: _setup.addressItems,
          "company-card-href": _setup.isMobile
            ? undefined
            : _setup.companyCardHref,
          "head-office-href": _setup.headOfficeHref,
          "physical-address": _setup.physicalAddress,
          "is-mobile": _setup.isMobile,
        },
      }),
      _vm._v(" "),
      _setup.showMediaSection
        ? _c(_setup.MediaSection, {
            class: { "px-4": _setup.isMobile },
            attrs: {
              "site-domain": _setup.siteDomain,
              "physical-address": _setup.physicalAddress,
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _c(_setup.DocumentsSection, {
        class: { "px-4": _setup.isMobile },
        attrs: {
          title: _setup.t("Документы юридического лица", _setup.options),
          items: _setup.documents,
          "updated-date": _setup.documentsUpdatedDate,
          "is-mobile": _setup.isMobile,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }